<template>
  <div
    v-if="Array.isArray(parcel_json.Problem_Reports) && parcel_json.Problem_Reports.length > 0"
    :class="{'spl-parcel-detail-block-problem-report-vertical': vertical, 'spl-parcel-detail-block-problem-report-error': error}"
    class="spl-parcel-detail-block-problem-report">
    <div class="spl-parcel-detail-block-problem-report__label">
      {{ label }}
    </div>

    <!-- *********************** Body of the block *********************************** -->
    <div class="spl-parcel-detail-block-problem-report__body">
      <!-- *********************** Block with active problems *********************************** -->
      <div
        v-for="(item, index) in active_problem_report_content"
        :key="'detailBlockActiveProblem' + index"
        :class="{'spl-parcel-detail-block-problem-report__body__content-blocks': contentBlocks}"
        class="spl-parcel-detail-block-problem-report__body__content">
        <hr v-if="index > 0">
        <!-- ***********************Active Problems *********************************** -->
        <div class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.PROBLEM_TYPE_DESCRIPTION }}
        </div>
        <div class="spl-parcel-detail-block-problem-report__body__content__value">
          {{ item.problem_type_description }}
        </div>
        <div v-if="item.provider_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.RESPONSIBLE_PROVIDER_NAME }}
        </div>
        <div v-if="item.provider_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.provider_name }}
        </div>
        <div v-if="item.responible_customer_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.RESPONSIBLE_CUSTOMER_NAME }}
        </div>
        <div v-if="item.responible_customer_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.responible_customer_name }}
        </div>
        <div v-if="item.problem_freetext !== ''" class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.PROBLEM_FREETEXT }}
        </div>
        <div v-if="item.problem_freetext !== ''" class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.problem_freetext }}
        </div>
        <div v-if="item.estimated_delivery !== ''" class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.NEW_ESTIMATED_DELIVERY_TIME }}
        </div>
        <div v-if="item.estimated_delivery !== ''" class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.estimated_delivery }}
        </div>
        <div class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.CREATED_BY }}
        </div>
        <div class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.created_user_name }}
        </div>
        <div class="spl-parcel-detail-block-problem-report__body__content__label">
          {{ constants.PARCEL_FIELD_LABELS.CREATED_AT }}
        </div>
        <div class="spl-parcel-detail-block-problem-report__body__content__value ">
          {{ item.created_timestamp }}
        </div>
        <div
          v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.DELETE)"
          class="spl-parcel-detail-block-problem-report__function-button"
          @click="deactivate_problem_report(item.problemReportId)">
          Deactivate
        </div>
        <div
          v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.ADD_PROBLEM_REPORT_MEASURE)"
          class="spl-parcel-detail-block-problem-report__function-button"
          @click="add_problem_report_measure(item.problemReportId)">
          Add Measure
        </div>
      </div>
      <div
        v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.LIST) && inactive_problem_report_content.length > 0"
        class="spl-parcel-detail-block-problem-report__expand-list"
        @click="toggleList">
        {{ expandListLabel }}
      </div>

      <!-- *********************** Inactive Problems *********************************** -->
      <div v-if="expandList">
        <div
          v-for="(item, index) in inactive_problem_report_content"
          :key="'detailBlockInActiveProblem' + index"
          :class="{'spl-parcel-detail-block-problem-report__body__content-blocks': contentBlocks}"
          class="spl-parcel-detail-block-problem-report__body__content">
          <hr>
          <div class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.PROBLEM_TYPE_DESCRIPTION }}
          </div>
          <div class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.problem_type_description }}
          </div>
          <div v-if="item.provider_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.RESPONSIBLE_PROVIDER_NAME }}
          </div>
          <div v-if="item.provider_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.provider_name }}
          </div>
          <div v-if="item.responible_customer_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.RESPONSIBLE_CUSTOMER_NAME }}
          </div>
          <div v-if="item.responible_customer_name !== ''" class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.responible_customer_name }}
          </div>
          <div v-if="item.problem_freetext !== ''" class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.PROBLEM_FREETEXT }}
          </div>
          <div v-if="item.problem_freetext !== ''" class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.problem_freetext }}
          </div>
          <div v-if="item.estimated_delivery !== ''" class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.NEW_ESTIMATED_DELIVERY_TIME }}
          </div>
          <div v-if="item.estimated_delivery !== ''" class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.estimated_delivery }}
          </div>
          <div class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.CREATED_BY }}
          </div>
          <div class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.created_user_name }}
          </div>
          <div class="spl-parcel-detail-block-problem-report__body__content__label-inactive">
            {{ constants.PARCEL_FIELD_LABELS.CREATED_AT }}
          </div>
          <div class="spl-parcel-detail-block-problem-report__body__content__value-inactive ">
            {{ item.created_timestamp }}
          </div>
          <div
            v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.ADD_PROBLEM_REPORT_MEASURE)"
            class="spl-parcel-detail-block-problem-report__function-button"
            @click="add_problem_report_measure(item.problemReportId)">
            Add Measure
          </div>
          <hr>
        </div>
      </div>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block-problem-report__highlight">
      {{ highlight }}
    </div>
    <add-measure-modal ref="addMeasureModal" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
export default {
  name: 'ParcelDetailBlockProblemReport',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'error',
    'contentBlocks',
    'vertical',
    'originalParcelJson'
  ],
  data () {
    return {
      constants,
      active_problem_report_content: [],
      inactive_problem_report_content: [],
      expandList: false,
      parcel_json: this.originalParcelJson
    }
  },
  computed: {
    expandListLabel () {
      return this.expandList ? 'Hide inactive' : 'Show inactive'
    }
  },
  watch: {
    // Reload the problem report (list) if the parcel json is updated.
    originalParcelJson (newParcelJson) {
      this.parcel_json = newParcelJson
      this.set_Problem_Report()
    }
  },
  mounted () {
    this.set_Problem_Report()
  },
  methods: {
    toggleList () {
      this.expandList = !this.expandList
    },

    set_Problem_Report () {
      this.problem_report_history = []
      this.active_problem_report_content = []
      this.inactive_problem_report_content = []

      // Check if there are problem_reports
      if (this.parcel_json.Problem_Reports !== '') {
        // Loop through all problem reports
        var problemReportContent = {}
        for (var value in this.parcel_json.Problem_Reports) {
          // Only show active problem_reports
          problemReportContent = {}
          problemReportContent = {
            problemReportId: this.parcel_json.Problem_Reports[value].Problem_Report_ID,
            problem_type_description: this.parcel_json.Problem_Reports[value].Problem_Type_Description,
            provider_name: this.parcel_json.Problem_Reports[value].Responsible_Provider_Name !== '' && this.parcel_json.Problem_Reports[value].Responsible_Provider_Name != null ? this.parcel_json.Problem_Reports[value].Responsible_Provider_Name : '',
            responible_customer_name: this.parcel_json.Problem_Reports[value].Responsible_Customer_Name != null && this.parcel_json.Problem_Reports[value].Responsible_Customer_Name !== '' ? this.parcel_json.Problem_Reports[value].Responsible_Customer_Name : '',
            problem_freetext: this.parcel_json.Problem_Reports[value].Problem_Freetext !== '' && this.parcel_json.Problem_Reports[value].Problem_Freetext != null ? this.parcel_json.Problem_Reports[value].Problem_Freetext : '',
            estimated_delivery: this.parcel_json.Problem_Reports[value].Estimated_Delivery_Time !== '' && this.parcel_json.Problem_Reports[value].Estimated_Delivery_Time !== '0001-01-01T00:00:00' ? this.formatDate(this.parcel_json.Problem_Reports[value].Estimated_Delivery_Time, true, 'YYYY-MM-DD HH:mm') : '',
            created_user_name: this.parcel_json.Problem_Reports[value].Created_User_Name,
            created_timestamp: this.formatDate(this.parcel_json.Problem_Reports[value].Created_Timestamp, true, 'YYYY-MM-DD HH:mm')
          }

          // Decide to push it to active or inactive list
          if (this.parcel_json.Problem_Reports[value].Active === true) {
            this.active_problem_report_content.push(problemReportContent)
          } else {
            this.inactive_problem_report_content.push(problemReportContent)
          }
        }
      }
    },

    // Checks which fields were updated and
    deactivate_problem_report (problemReportId) {
      // deactivate the problem report
      webApi.problem_report.deactivate_Problem_Report_By_ID(problemReportId)
        .then((response) => {
          this.$toast('Problem Report was deactivated', constants.defaultToastOptions())
          this.active_problem_report_content.forEach((item, index) => {
            if (item.problemReportId === problemReportId) {
              this.inactive_problem_report_content.unshift(item)
              this.active_problem_report_content.splice(index, 1)
            }
          })
          this.$emit('parcelUpdated')
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    add_problem_report_measure (problemReportID) {
      this.$refs.addMeasureModal.openModal([problemReportID])
    }
  }

}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block-problem-report {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        @include mobile() {
            padding-bottom: 20px;
        }
        &-error {
            background-color: $redBackgroundLight;
            border-left: 2px solid $red;

        }

        &-vertical {
            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            .spl-parcel-detail-block-problem-report {
                &__label,
                &__body {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;

                }

                &__label {
                    width: 16.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__body {
                    width: 41.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
            }
        }

        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }

        &__body {
            .spl-button,
            .spl-textarea,
            .spl-dropdown {
                margin: 0 0 10px 0;
            }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }

                &-blocks,
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;

                    &-inactive{
                      float: left;
                      min-height: 10px;
                      vertical-align: top;
                      width: 50%;
                      color:$disabledYellow;
                    }
                    @include mobile() {
                        width: 100%;
                    }

                }

                &__value {
                    font-weight: 600;

                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }

            }
        }
        &__expand-list {
            color: $middleYellow;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            margin-top: 15px;
            transition: color $shortTransition ease-in-out;

            &:hover {
                color: $mainInputColor;
            }
        }
        &__function-button {
            color: $middleYellow;
            cursor: pointer;
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            margin-right: 20px;
            transition: color $shortTransition ease-in-out;

            @include mobile() {
                margin-right: 10px;
            }
            &:hover {
                color: $yellowButtonLabelHover;
            }
        }
        &__highlight {
            background-color: $tableRowBackgroundColorSelected;
            border-left: 2px solid $middleYellow;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 30px -17px -30px -17px;
            padding: 15px;
        }
    }
</style>
